import { Typography } from '@mui/material';
import React from 'react';

const CopyrightNotification: React.FC = () => {
    return (
        <div>
            <Typography variant='h4' textAlign='center' mt={5}>Copyright Notification</Typography>
        </div>
    );
};

export default CopyrightNotification;
